export enum IroNamRequestStatus {
    SAVED = 'saved',
    SUBMITTED = 'submitted',
    PENDING_CUSTOMER_ACTION = 'pending-customer-action',
    REFERRED_OUT = 'referred-out',
    UNDER_REVIEW = 'under-review',
    CLOSED = 'closed'
}

export const iroNamStatusToDisplayName = new Map<IroNamRequestStatus, string>([
    [IroNamRequestStatus.SAVED, 'saved'],
    [IroNamRequestStatus.SUBMITTED, 'submitted'],
    [IroNamRequestStatus.PENDING_CUSTOMER_ACTION, 'pending requestor response'],
    [IroNamRequestStatus.REFERRED_OUT, 'referred out'],
    [IroNamRequestStatus.UNDER_REVIEW, 'under review'],
    [IroNamRequestStatus.CLOSED, 'closed']
]);
